export default "__VITE_ASSET__f0cd5187__"